/* globals gtag dataLayer */
import { logWithOffset } from "../../logWithOffset";

let settings = null;

const isEnabled = () => {
  return typeof(settings.gaMeasurementId) === 'string' && settings.gaMeasurementId.length > 0;
};

const setup = async (s) => {
  settings = s;
  if (isEnabled()) {
      logWithOffset("Configuring Google");
      const head      = document.getElementsByTagName('head')[0];
      const newScript = document.createElement("script");
      newScript.async = true;
      newScript.src   =  `https://www.googletagmanager.com/gtag/js?id=${settings.gaMeasurementId}`;
      head.appendChild(newScript);

      window.dataLayer = window.dataLayer || [];
      window.gtag = function () {
        dataLayer.push(arguments);
      }
      window.gtag('js', new Date());
      window.gtag('config', settings.gaMeasurementId, { 'send_page_view': false });
  }
};


const handlePageView = async (e) => {
  gtag('event', 'page_view');
}

const handleCheckoutStarted = async (e) => {
}

const handleAcceptUpsell = async (e) => {
  gtag('event', 'accepted-upsell', {
    transaction_id: e.sessionCartId,
    event_category: "ecommerce",
    event_label: e.upsellPageName,
    value: e.value,
    currency: e.currency,
  });

}

const handlePurchase = async (e) => {
  gtag('event', 'purchase', {
    transaction_id: e.sessionCartId,
    value: e.subTotalValue,
    currency: e.currency,
  });

};

const fire = async (e) => {
  if (!isEnabled()) {
    return;
  }

  switch(e.eventType) {
    case 'page_view':
      return handlePageView(e);
    case 'accepted_upsell':
      return handleAcceptUpsell(e);
    case 'checkout_started':
      return handleCheckoutStarted(e);
    case 'checked_out':
      return handlePurchase(e);
  }
};

export default { setup, fire };
